<div class="modal-overlay" (click)="fecharModal()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-file-invoice-dollar"></i>
          {{ novaConta.pago ? 'Visualizar Conta' : (novaConta.id ? 'Alterar Conta' : 'Nova Conta') }}
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12">
        <label for="descricao" class="form-label">Descrição</label>
        <input type="text" class="form-control" name="descricao" id="descricao" [(ngModel)]="novaConta.descricao"
               placeholder="Digite a descrição da conta" [disabled]="novaConta.pago"
               [ngClass]="{'is-invalid': errors.descricao}">
        <span class="error mensagem-erro" *ngIf="errors.descricao">A descrição é obrigatória</span>
      </div>


      <div class="col-md-6">
        <label for="valor" class="form-label">Valor</label>
        <input type="text" class="form-control" name="valor" id="valor" [(ngModel)]="novaConta.valor" [disabled]="novaConta.pago"
               mask="separator.2" prefix="R$ " thousandSeparator="." decimalMarker="," [dropSpecialCharacters]="true"
               [ngClass]="{'is-invalid': errors.valor}">
        <span class="error mensagem-erro" *ngIf="errors.valor">O valor é obrigatório</span>
      </div>

      <div class="col-md-6">
        <label for="dataVencimento" class="form-label">Data de Vencimento</label>
        <input type="date" class="form-control" name="dataVencimento" id="dataVencimento" [(ngModel)]="novaConta.dataVencimento" [disabled]="novaConta.pago"
               [ngClass]="{'is-invalid': errors.dataVencimento}">
        <span class="error mensagem-erro" *ngIf="errors.dataVencimento">A data é obrigatória</span>
      </div>

      <div class="col-md-6">
        <label for="categoria" class="form-label">Categoria</label>
        <ng-select *ngIf="isContaAPagar"
                   [items]="categoriasPagar"
                   bindLabel="nome"
                   bindValue="id"
                   [(ngModel)]="novaConta.categoria"
                   id="categoria"
                   [disabled]="novaConta.pago"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': errors.categoria}"
                   placeholder="Selecione uma categoria">
        </ng-select>
        <ng-select *ngIf="isContaAReceber"
                   [items]="categoriasReceber"
                   bindLabel="nome"
                   bindValue="id"
                   [(ngModel)]="novaConta.categoria"
                   id="categoria"
                   [disabled]="novaConta.pago"
                   [clearable]="false"
                   [ngClass]="{'is-invalid': errors.categoria}"
                   placeholder="Selecione uma categoria">
        </ng-select>
        <input *ngIf="!isContaAPagar && !isContaAReceber" type="number" class="form-control" name="categoria" id="categoria" [(ngModel)]="novaConta.categoria" [disabled]="novaConta.pago" [ngClass]="{'is-invalid': errors.categoria}">
        <span class="error mensagem-erro" *ngIf="errors.categoria">A categoria é obrigatória</span>
      </div>



      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-light" (click)="fecharModal()">{{ novaConta.pago ? 'Fechar' : 'Cancelar' }}</button>
        <button *ngIf="!novaConta.pago" type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvarConta()" [disabled]="!novaConta.descricao || !novaConta.valor || !novaConta.dataVencimento || novaConta.categoria === undefined || novaConta.categoria === null || novaConta.categoria === ''">
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
